var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptimaleOberflaechenVorbereitung = function SvgOptimaleOberflaechenVorbereitung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Optimale_Oberflaechen-vorbereitung_svg__Ebene_2",
    viewBox: "0 0 119.8 77.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Optimale_Oberflaechen-vorbereitung_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:3px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Optimale_Oberflaechen-vorbereitung_svg__Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.99 75.34 3.2 45.01l57.72-30.46 55.73 31.39z",
    className: "Optimale_Oberflaechen-vorbereitung_svg__cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.38,
    cy: 27.41,
    r: 25.91,
    className: "Optimale_Oberflaechen-vorbereitung_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.12 44.68 24.37 24.37",
    style: {
      strokeWidth: "2.5px",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  })));
};
export default SvgOptimaleOberflaechenVorbereitung;